import React, { useRef, useEffect, useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";

const productCategories = [
    { id: 1, title: "Solitaries", imgSrc: "/assets/solitarry.jpg", link: "/products?category=Solitaries" },
    { id: 2, title: "Men's Jewellery", imgSrc: "/assets/mensjewell.jpg", link: "/products?category=Men's Jewellery" },
    { id: 3, title: "Nose ring", imgSrc: "/assets/nosering.jpg", link: "/products?category=Nose ring" },
    { id: 4, title: "Anklets", imgSrc: "/assets/anklet.jpg", link: "/products?category=Anklets" },
    { id: 5, title: "Rings", imgSrc: "/assets/ring.jpg", link: "/products?category=Rings" },
    { id: 6, title: "Pendents", imgSrc: "/assets/pendants.jpg", link: "/products?category=Pendents" },
    { id: 7, title: "Necklaces", imgSrc: "/assets/neklace.jpg", link: "/products?category=Necklaces" },
    { id: 8, title: "Earrings", imgSrc: "/assets/earring.jpg", link: "/products?category=Earrings" },
    { id: 9, title: "Bangles", imgSrc: "/assets/bangles.jpg", link: "/products?category=Bangles" },
    { id: 10, title: "Bracelets", imgSrc: "/assets/bracelet.jpg", link: "/products?category=Bracelets" },
    { id: 11, title: "Chains", imgSrc: "/assets/chain.jpg", link: "/products?category=Chain" },
    { id: 12, title: "Kada", imgSrc: "/assets/kada.jpg", link: "/products?category=Kada" },
];

const AnimeCards = () => {
    const cardRef = useRef(null);
    const [cardWidth, setCardWidth] = useState(0);
    const [isAnimating, setIsAnimating] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        if (cardRef.current) {
            setCardWidth(cardRef.current.offsetWidth + 20);
        }
        const interval = setInterval(() => {
            setIsAnimating(true);
            setTimeout(() => setIsAnimating(false), 1500);
        }, 4000);
        return () => clearInterval(interval);
    }, []);

    return (
        <div className="wrapall">
            <div className="menu-wrap container">
                {productCategories.map((card, index) => (
                    <motion.div
                        key={card.id}
                        className="cards"
                        ref={index === 0 ? cardRef : null}
                        initial={{ x: 0 }}
                        animate={{
                            x: isAnimating ? (index % 2 === 0 ? cardWidth : -cardWidth) : 0,
                        }}
                        transition={{
                            duration: 1.5,
                            ease: "easeInOut",
                            delay: index * 0.05,
                        }}
                    >
                        <div
                            className="menu-item"
                            onClick={() => navigate(card.link)}
                            style={{ cursor: "pointer" }}
                        >
                            <div className="image-wrap">
                                <img
                                    className="img-responsive-c"
                                    src={card.imgSrc}
                                    alt={card.title}
                                />
                            </div>
                        </div>
                        <p className="title">{card.title}</p>
                    </motion.div>
                ))}
            </div>
        </div>
    );
};

export default AnimeCards;
